import Icons from "@/src/components/Icons";
import { useUserStore } from "@/src/store/useUserStore";
import { digitsEnToFa } from "@persian-tools/persian-tools";
import { Link, useNavigate } from "react-router-dom";
import { useRaychatChat } from "./Raychat";
import { useEffect, useRef, useState } from "react";
import { raychatApi } from "@/src/utils/api/raychat";
import { goftinoApi } from "@/src/utils/api/goftino";
import emptmom from "../../assets/img/emptMom.png";
import { toast } from "react-toastify";

function Profile() {
  const { user } = useUserStore();

  const [finalUserData, setFinalUserData] = useState<any>({
    email: 'tech@raychat.io',
    name: user?.alias || '',
    about: 'about me :)',
    phone: user?.mobilePhoneNumber || '',
    avatar: user?.profilePictureUrl ? user.profilePictureUrl : emptmom,
    updateOnce: true
  });
  const history = useNavigate();
  const goftinoIdSentRef = useRef(false);
  useEffect(() => {
    const checkRaychatReady = () => {
      console.log("checkRaychatReady");
      if (!user) {
        return;
      }
      
      if (user && typeof window.Raychat !== "undefined") {
        console.log("user", user);
        let raychatId: string | null = null;

        if (user && user.goftinoId) {
          console.log("user.goftinoId", user.goftinoId);
          raychatId = String(user.goftinoId);
          if (window.Raychat?.loadUser && raychatId) {
            window.Raychat.loadUser(raychatId);
          }
        } else {
          console.log("userData else");
          const userData = window.Raychat?.getUser();
          console.log("userData", userData);
          raychatId = userData?.id ? String(userData.id) : (userData?.userId ? String(userData.userId) : null);
          if (raychatId) {
            raychatApi.updateId(raychatId);
          }
        }
        setFinalUserData({
          email: 'tech@raychat.io',
          name: user?.alias || '',
          about: 'about me :)',
          phone: user?.mobilePhoneNumber || '',
          avatar: user?.profilePictureUrl ? user.profilePictureUrl : emptmom,
          updateOnce: true
        });

        window.Raychat.hideWidget();
      } else {
        setTimeout(checkRaychatReady, 1000);
      }
    };

    window.addEventListener("raychat_ready", checkRaychatReady);

    return () => {
      window.removeEventListener("raychat_ready", checkRaychatReady);
    };
  }, [user]);

  useEffect(() => {
    goftinoIdSentRef.current = false;

    const checkGoftinoReady = () => {
      if (!user) {
        return;
      }

      if (user && typeof window.Goftino !== "undefined") {
        if (!user.goftinoId && !goftinoIdSentRef.current) {
          if (user.goftinoId) {
            goftinoIdSentRef.current = true;
            goftinoApi.updateId(user.goftinoId);
          } else {
            const goftinoId = window.Goftino?.getUserId();
            if (goftinoId) {
              goftinoIdSentRef.current = true;
              goftinoApi.updateId(goftinoId);
            }
          }
        }
      } else {
        setTimeout(checkGoftinoReady, 1000);
      }
    };

    window.addEventListener("goftino_ready", checkGoftinoReady);

    return () => {
      window.removeEventListener("goftino_ready", checkGoftinoReady);
    };
  }, [user]);

  useRaychatChat(
    "c8315074-c017-4d75-9eed-87f3fdafa4b6",
    {
      mobile: { marginRight: 20, marginBottom: 80, marginLeft: 10 },
      desktop: { marginRight: 100, marginBottom: 50, marginLeft: 30 },
    }
  );
  return (
    <div>
      <h4
        className="title text-xl font-extrabold flex items-center cursor-pointer"
        onClick={() => history("/")}
      >
        <Icons name="arrowBack" fill="none" size={40} />
        نمایش
      </h4>
      <div className="items flex flex-col gap-4 ">
        <Link
          to={"/profile/show"}
          className="item-profile h-[116px] bg-white rounded-xl mt-4 flex p-2 items-center justify-between shadow-mmpz cursor-pointer"
        >
          <div className="item flex gap-8">
            <img
              src={
                user?.profilePictureUrl
                  ? user.profilePictureUrl
                  : emptmom
              }
              alt=""
              className="w-[80px] h-[80px] rounded-full shadow-xl"
            />
            <div className="item flex-col gap-3 flex">
              <p className="font-bold ">{user?.alias}</p>
              <p className="text-primary-300 text-sm">{user?.name}</p>
              <p className="text-gray-200-mmpz text-sm">
                {user ? digitsEnToFa(user.mobilePhoneNumber) : null}
              </p>
            </div>
          </div>

          <div className="item">
            <Icons name="arrowLeft" fill="none" stroke="#1E1E1E" size={40} />
          </div>
        </Link>
        <div
          className="item-goftino min-h-[70px] flex justify-between bg-white items-center p-2 rounded-xl shadow-mmpz cursor-pointer"
          onClick={async () => {
            if (!user) {
              toast.error("لطفا ابتدا وارد حساب کاربری خود شوید", {
                position: "top-right",
                autoClose: 3000,
              });
              return;
            }

            if (typeof window.Raychat === "undefined") {
              toast.error("رایچت آماده نیست، لطفا چند لحظه صبر کنید", {
                position: "top-right",
                autoClose: 3000,
              });
              return;
            }

        
            console.log("finalUserData", finalUserData);
            window.Raychat.setUser(finalUserData);
            window.Raychat.openWidget();
          }}
        >
          <h4 className="text-xl"> ارتباط با تیم تولید</h4>
          <Icons name="arrowLeft" fill="none" stroke="#1E1E1E" size={40} />
        </div>
        <div
          className="item-goftino min-h-[70px] flex justify-between bg-white items-center p-2 rounded-xl shadow-mmpz cursor-pointer"
          onClick={() => {
            history("/profile/comments");
          }}
        >
          <h4 className="text-xl">نظر کاربران</h4>
          <Icons name="arrowLeft" fill="none" stroke="#1E1E1E" size={40} />
        </div>
        <Link
          to={"/profile/estimate"}
          className="item-goftino min-h-[70px] flex justify-between bg-white items-center p-2 rounded-xl shadow-mmpz cursor-pointer"
        >
          <h4 className="text-xl">برنامه هفتگی و تخمین</h4>
          <Icons name="arrowLeft" fill="none" stroke="#1E1E1E" size={40} />
        </Link>
        <div
          className="item-goftino min-h-[70px] flex justify-between bg-white items-center p-2 rounded-xl shadow-mmpz cursor-pointer"
          onClick={() => {
            history("/profile/food");
          }}
        >
          <h4 className="text-xl">غذاها</h4>
          <Icons name="arrowLeft" fill="none" stroke="#1E1E1E" size={40} />
        </div>
        <div className="item-goftino min-h-[70px] flex justify-between bg-white items-center p-2 rounded-xl shadow-mmpz">
          <h4 className="text-xl text-[#D2D2D2]">اعلان‌ها</h4>
          <Icons name="arrowLeft" fill="none" size={40} stroke="#D2D2D2" />
        </div>
      </div>
    </div>
  );
}

export default Profile;
